import { render } from "./videoLibraryManage.vue?vue&type=template&id=13523c27&scoped=true"
import script from "./videoLibraryManage.vue?vue&type=script&lang=js"
export * from "./videoLibraryManage.vue?vue&type=script&lang=js"

import "./videoLibraryManage.vue?vue&type=style&index=0&id=13523c27&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13523c27"]])

export default __exports__